<div class="wrapper">
  <input type="file" class="file-input" (change)="onFileSelected($event)" [accept]="accept()" #fileUpload />

  <div
    class="file-upload"
    (click)="fileUpload.click()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (keypress)="fileUpload.click()"
    tabindex="0"
    [ngClass]="{ dragover: isDragOver() }"
  >
    <ng-content></ng-content>
  </div>
  @if (fileName()) {
    <div class="file-name">
      <span>{{ fileName() }}</span>
      <app-icon icon="delete" (click)="clearFile()"></app-icon>
    </div>
  }
  @if (error()) {
    <div class="error">
      <span i18n>Invalid file, please only use files ending with: {{ accept() }}</span>
    </div>
  }
</div>
